import AsyncSelect from 'react-select/async';
import { MultiValue } from 'react-select';
import { SearchType } from '../../../data/__generated__/globalTypes';
import React from 'react';
import { useForecastingSettings } from '../../ForecastingContextProvider';
import { usePrimaryForecastingState } from '../ForecastingPanel';
import { useAutoCompleteOptions, useForecastingFilterValidation } from './ForecastingFilters';
import ErrorTooltip from '../ErrorTooltip';
import { ReactComponent as LoadingState } from 'svg/loader.svg';

export default function DMA() {
    const { forecastingSettings, updateForecastingSetting } = useForecastingSettings();
    const { isPrimaryForecastingLoading } = usePrimaryForecastingState();
    const loadOptions = useAutoCompleteOptions(SearchType.METRO);
    const { loading, data } = useForecastingFilterValidation(SearchType.METRO);

    let tooltip = null;
    if (loading) {
        tooltip = <LoadingState className='inline-flex CampaignSpendOverlayLoadingState h-4 w-4 ml-1' />;
    } else {
        if (data?.filterDependencyValidation) {
            tooltip = (
                <ErrorTooltip id={'city-error-tooltip'}>
                    <div>
                        The selected DMAs are no longer valid. They may be part of a country or region that is no longer selected.
                    </div>
                </ErrorTooltip>
            );
        }
    }

    return (
        <div className='mt-4 w-80'>
            <div style={{flexDirection: 'row'}}>
                <label
                    htmlFor='metro'
                    className='block-inline text-sm font-medium text-gray-700'
                >
                    DMA
                </label>
                {tooltip}
            </div>
            <AsyncSelect
                key={'metro:' + JSON.stringify(forecastingSettings)}
                isDisabled={isPrimaryForecastingLoading}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                isMulti
                name='metros'
                className='basic-multi-select'
                classNamePrefix='select'
                onChange={(newValue: MultiValue<{
                    label: string,
                    value: string
                }>) => updateForecastingSetting({
                    metroFilter: newValue.map(it => ({
                        label: it.label,
                        value: it.value
                    }))
                })}
                defaultOptions
                loadOptions={loadOptions}
                defaultValue={forecastingSettings.metroFilter}
            />
        </div>
    );
}
